import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import type { OnboardingNudge } from 'fym-shared/src/music24/onboardingChecklist';
import { TypedMemo } from '../../common/types';
import { checklistMessages as messages } from './checklistMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the checklist; each part uses its own slice of it */
import styles from './FirstReleaseChecklist.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChecklistNudgeButtonProps {
  nudge: OnboardingNudge;
  onNudge: (nudge: OnboardingNudge) => void;
}

/** The small "Add a cover" button on a done item that carries a nudge. */
const ChecklistNudgeButtonComponent: React.FC<ChecklistNudgeButtonProps> = ({ nudge, onNudge }) => {
  const intl = useIntl();
  const run = useCallback(() => onNudge(nudge), [nudge, onNudge]);
  return (
    <button type="button" className={styles.actionLink} onClick={run} data-testid={`checklist-nudge-${nudge.kind}`}>
      {intl.formatMessage(messages.nudgeCover)}
    </button>
  );
};

export const ChecklistNudgeButton = TypedMemo(ChecklistNudgeButtonComponent);
